import VerificationModal from './VerificationModal'

export default VerificationModal
